<template>
  <div class="dft-title_text">
    <!-- 辅助分割 -->
    <div class="attr-item-box" v-for="(item,index) in value" :key="index">
      <div class="attr-item-typestyle" v-if="item.sid == 'white_line_s1'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="1">辅助空白</el-radio-button>
            <el-radio-button label="2">辅助线</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="value[0].value == '1'&&item.sid == 'white_line_s2'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <el-slider v-model="item.value" :min="item.min" :max="item.max"
            show-input :show-input-controls="false" class="custon_slider" input-size="mini"></el-slider>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="value[0].value == '2'&&item.sid == 'white_line_s3'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="1px solid"><span style="font-size: 14px;">实线</span></el-radio-button>
            <el-radio-button label="1px dashed"><span style="font-size: 14px;">虚线</span></el-radio-button>
            <el-radio-button label="1px dotted"><span style="font-size: 14px;">点线</span></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="value[0].value == '2'&&item.sid == 'white_line_s4'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="0"><span style="font-size: 14px;">无边距</span></el-radio-button>
            <el-radio-button label="0 15px"><span style="font-size: 14px;">左右留边</span></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="value[0].value == '2'&&item.sid == 'white_line_s5'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <div class="colorPicker">
            <el-button type="text" @click="item.value = item.default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="item.value" show-alpha></el-color-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      // 模板默认数据
      assemblyAttr666: JSON.stringify(
        [
          {
            label: '分割类型',
            value: '1',
            sid: 'white_line_s1',
            showList: {
              '1': '辅助空白',
              '2': '辅助线'
            },
            key: 'white_line',
            type: 'style',
            tag: 'radio'
          }, // 0
          {
            label: '空白高度',
            value: 30,
            sid: 'white_line_s2',
            min: 4,
            max: 100,
            key: 'height',
            type: 'style',
            tag: 'el-slider'
          }, // 1
          {
            label: '选择样式',
            value: '1px solid',
            sid: 'white_line_s3',
            showList: {
              '1px solid': '实线',
              '1px dashed': '虚线',
              '1px dotted': '点线'
            },
            key: 'border-top',
            type: 'style',
            tag: 'radio'
          }, // 2
          {
            label: '左右边距',
            value: '0',
            sid: 'white_line_s4',
            showList: {
              '0': '无边距',
              '0 15px': '左右留边'
            },
            key: 'padding',
            type: 'style',
            tag: 'radio'
          }, // 3
          {
            label: '辅助线颜色',
            value: '#e5e5e5',
            sid: 'white_line_s5',
            showList: {},
            default: '#e5e5e5',
            key: 'border-color',
            type: 'style',
            tag: 'ColorPicker'
          }// 4
        ]
      )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {

  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.attr-item-box{
  padding: 6px 10px;
  margin-bottom: 10px;
  .attr-item-typedata{
    .attr-item-label{
      margin-bottom: 5px;
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 40px)/4);
          height: 90px;
          margin: 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #333;
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .img_info{
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;
            .ii-img-box{
              width: 80px;
              height: 100px;
              position: relative;
              .ii-img{
                width: 100%;
                height: 100%;
              }
              .ii-img-btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
            .ii-link-box{
              width: calc(100% - 80px);
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }
              .ii-link{}
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .attr-item-label{
      color: #969799;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

}

.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
</style>
